"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setWarnings() {
    return (state, actions, { validationResults }) => {
        const tabNames = Object.keys(state.tabs);
        const tabs = tabNames.reduce((tabs, tabName) => {
            const warnings = (validationResults[tabName] || []).slice();
            tabs[tabName] = Object.assign({}, tabs[tabName], { warnings });
            return tabs;
        }, Object.assign({}, state.tabs));
        return Object.assign({}, state, { tabs: Object.assign({}, tabs) });
    };
}
exports.setWarnings = setWarnings;
//# sourceMappingURL=set-warnings.js.map